document.addEventListener('DOMContentLoaded', function () {
  const tabNavButtons = document.querySelectorAll('.fct-tab-nav');
  const tabContents = document.querySelectorAll('.fct-tab-content');

  function activateTab(index) {
    tabNavButtons.forEach((btn, i) => {
      const isActive = i === index;
      btn.classList.toggle('active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    tabContents.forEach((content, i) => {
      const isActive = i === index;
      content.classList.toggle('active', isActive);

      // When switching tabs, reset any filters + keyword active state
      if (isActive) {
        clearKeywordActive(content);
        showAllItems(content);

        // Auto-apply default keyword if one is marked data-default="true"
        const defaultKeyword = content.querySelector('.fct-keyword[data-default="true"]');
        if (defaultKeyword) defaultKeyword.click();
      }
    });
  }

  function clearKeywordActive(tabPanel) {
    tabPanel.querySelectorAll('.fct-keyword.active').forEach(el => el.classList.remove('active'));
  }

  // Find items inside the slider that can be filtered.
  // We support two selectors:
  // 1) [data-fct-item] (recommended)
  // 2) fallback .grid__item (works if your carousel uses Dawn grid items)
  function getItems(tabPanel) {
    const items = tabPanel.querySelectorAll('[data-fct-item]');
    if (items && items.length) return Array.from(items);
    return Array.from(tabPanel.querySelectorAll('.grid__item'));
  }

  function showAllItems(tabPanel) {
    const items = getItems(tabPanel);
    items.forEach(item => {
      item.style.removeProperty('display');
      item.removeAttribute('aria-hidden');
    });
  }

  function normalize(s) {
    return (s || '').toString().trim().toLowerCase();
  }

  // Read filterable data from item dataset.
  // Expected dataset keys (recommended):
  // data-tags="tag1|tag2|tag3"
  // data-vendor="Dieselr Corp"
  // data-type="All-in-One Kit"
  function itemMatches(item, scope, value) {
    const val = normalize(value);

    if (!val) return true;
    if (scope === 'none') return true;

    if (scope === 'tag') {
      const tags = normalize(item.dataset.tags).split('|').map(t => t.trim()).filter(Boolean);
      return tags.includes(val);
    }

    if (scope === 'vendor') {
      return normalize(item.dataset.vendor) === val;
    }

    if (scope === 'product_type') {
      return normalize(item.dataset.type) === val;
    }

    return true;
  }

  function applyFilter(tabPanel, scope, value) {
    const items = getItems(tabPanel);

    // If no filter value, show all (and allow link navigation behavior)
    if (!value || scope === 'none') {
      showAllItems(tabPanel);
      return;
    }

    items.forEach(item => {
      const keep = itemMatches(item, scope, value);
      if (keep) {
        item.style.removeProperty('display');
        item.removeAttribute('aria-hidden');
      } else {
        item.style.display = 'none';
        item.setAttribute('aria-hidden', 'true');
      }
    });
  }

  // Keyword click handling
  document.querySelectorAll('.fct-keyword').forEach(keyword => {
    keyword.addEventListener('click', function (e) {
      const tabIndex = parseInt(this.getAttribute('data-tab-index'), 10);
      const scope = this.getAttribute('data-filter-scope') || 'none';
      const tag = this.getAttribute('data-filter-tag') || '';

      // Find the matching tab panel
      const tabPanel = document.querySelector(`.fct-tab-content[data-tab-index="${tabIndex}"]`);
      if (!tabPanel) return;

      // If there IS a filter tag/value, we filter in place (no navigation).
      // If there is NOT, we allow normal link navigation.
      if (tag && scope && scope !== 'none') {
        e.preventDefault();

        // Active UI state
        clearKeywordActive(tabPanel);
        this.classList.add('active');

        // Apply filter
        applyFilter(tabPanel, scope, tag);

        // Optional: scroll the slider back to start after filtering
        const slider = tabPanel.querySelector('.fct-collection-slider');
        if (slider) slider.scrollTo({ left: 0, behavior: 'smooth' });
      }
    });
  });

  // Tabs
  if (tabNavButtons.length > 0) activateTab(0);

  tabNavButtons.forEach((btn, index) => {
    btn.addEventListener('click', function () {
      activateTab(index);
    });
  });
});
